module.exports = __webpack_public_path__ + "assets/img/ic-message-hover.894a222f.svg";